import React from 'react';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import SearchBox from '../../../../../../common/SearchBox';
import SaveAltSharp from '@material-ui/icons/SaveAltSharp';
import StyledToolTip from '../../../../../../common/StyledToolTip';
import styles from './styles';
import CustomDateRangePicker from '../../../../DispatchChat/MessageHistory/components/CustomDateRangePicker';
import { PAST_PICKUP_GRID_FILTER_LIST, LAST_ONE_MONTH, STATIC_DATE_RANGE_LIST } from '../Constants';
import { subDays } from 'date-fns';
import { CustomDropdown } from '../../../DispatchPanel/EquipmentDefects/Grid/components';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const GridHeader = ({
  classes,
  gridApi,
  updateSearchText,
  exportCSV,
  onDateRangeChange,
  onFilterChange,
  selectedPickupData,
  onViewHistoryClick,
  selectedDateRange
}) => {
  const onChangeDateRange = (dateRange) => {
    onDateRangeChange(dateRange);
  };

  return (
    <div className={classes.headerStyle}>
      <div className={classes.iconContainer}>
        <span >
          <CustomDateRangePicker
            selectedDateRange={selectedDateRange}
            onChangeDateRange={onChangeDateRange}
            errorInfo={{
              selectedDateRange: ''
            }}
            labelText="Date Range"
            minDate={subDays(new Date(), LAST_ONE_MONTH + 1)}
            staticRanges={STATIC_DATE_RANGE_LIST}
          />
        </span>
        <span className={classes.dropdownContainer}>
          <CustomDropdown
            autoFocus={false}
            value={PAST_PICKUP_GRID_FILTER_LIST[0].label}
            options={PAST_PICKUP_GRID_FILTER_LIST}
            onChange={onFilterChange}
          />
        </span>
      </div>
      <div className={classes.iconContainer}>
        <span
          className={selectedPickupData ? classes.historyText : classes.historyTextDisable}
          onClick={selectedPickupData ? onViewHistoryClick : null}>
          View Pickup History
        </span>
        <span>
          <SearchBox onChange={updateSearchText} />
          <ClearAllFilterButton gridApi={gridApi} />
        </span>
        <span
          onClick={exportCSV}
          className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}>
          <StyledToolTip title="Export Data">
            <SaveAltSharp />
          </StyledToolTip>
        </span>
      </div>
    </div>
  );
};

export default compose(withStyles(styles))(GridHeader);
